export default "/images/a3865ce8c234f5c039df6fce3bbe96b5.avif";